import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoLanguage, IoChevronDown } from 'react-icons/io5';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  
  const languages = [
    { code: 'en', name: t('language.en') },
    { code: 'zh', name: t('language.zh') },
    { code: 'zh-TW', name: t('language.zh-TW') },
    { code: 'ja', name: t('language.ja') },
    { code: 'de', name: t('language.de') },
    { code: 'fr', name: t('language.fr') },
    { code: 'es', name: t('language.es') },
    { code: 'ko', name: t('language.ko') },
    { code: 'hi', name: t('language.hi') },
    { code: 'ar', name: t('language.ar') }
  ];
  
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  
  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('preferredLanguage', code);
    setShowDropdown(false);
  };
  
  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];
  
  return (
    <div className="language-switcher">
      <button onClick={toggleDropdown} className={showDropdown ? 'active-language' : ''}>
        <IoLanguage />
        {currentLanguage.name}
        <IoChevronDown size={12} />
      </button>
      
      {showDropdown && (
        <div className="language-dropdown">
          {languages.map((language) => (
            <div
              key={language.code}
              className={`language-option ${language.code === i18n.language ? 'active' : ''}`}
              onClick={() => changeLanguage(language.code)}
            >
              {language.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;